import { Yield } from '../../abacus/interfaces/yield.interface'

export const tagYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
